import React from 'react'
import { supportsContainerStyleQueries, type PresetPolyfillData } from '@wix/builder-presets-polyfill'
import styles from './builderComponent.scss'
import type { ILayoutDoneService, Experiments } from '@wix/thunderbolt-symbols'
import { useBuilderComponentPolyfill } from './hooks/useBuilderComponentPolyfill'

export const WrapBuilderComponent = (
	Comp: React.ComponentType<any>,
	builderComponentId: string,
	getPresetsPolyfillData: () => Record<string, PresetPolyfillData>,
	layoutDoneService: ILayoutDoneService | undefined,
	experiments: Experiments
) => {
	/**
	 * Component with polyfill side effect.
	 * Only used when Container Style Queries are not supported by the browser.
	 */
	const ComponentWithPolyfill = (componentProps: any) => {
		useBuilderComponentPolyfill({
			builderComponentId,
			getPresetsPolyfillData,
			layoutDoneService,
			experiments,
		})

		return React.createElement(Comp, componentProps)
	}

	return function WrappedBuilderComponent(props: any) {
		const { _wrapperProps, ...rest } = props

		return !supportsContainerStyleQueries()
			? React.createElement(ComponentWithPolyfill, rest)
			: React.createElement(Comp, rest)
	}
}
